import { FIQAssist  } from "./app";
import { Config, Inject } from "@fiqas/angular-utils";
import "@fiqas/ngcomponentrouter";

@Config({ module: FIQAssist })
class Configuration {
    constructor(
        @Inject('$locationProvider') $locationProvider: angular.ILocationProvider,
        @Inject('$httpProvider') $httpProvider: angular.IHttpProvider,
		@Inject('hotkeysProvider') hotkeysProvider,
		@Inject('agcLibraryLoaderProvider') agcLibraryLoaderProvider,
		@Inject('agcGstaticLoaderProvider') agcGstaticLoaderProvider
    ) {
        hotkeysProvider.useNgRoute = false;
        $locationProvider.html5Mode(true);
		$httpProvider.useApplyAsync(true);
		agcLibraryLoaderProvider.setLoader('gstatic');
		agcGstaticLoaderProvider.setVersion('41');
    }
}
